"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_MESSAGE_TYPE = void 0;
var SEND_MESSAGE_TYPE;
(function (SEND_MESSAGE_TYPE) {
    SEND_MESSAGE_TYPE["NORMAL"] = "NORMAL";
    SEND_MESSAGE_TYPE["PRIORITY"] = "PRIORITY";
    SEND_MESSAGE_TYPE["REMINDER"] = "REMINDER";
    SEND_MESSAGE_TYPE["LOCATION"] = "LOCATION";
})(SEND_MESSAGE_TYPE || (exports.SEND_MESSAGE_TYPE = SEND_MESSAGE_TYPE = {}));
